module.exports = __webpack_public_path__ + "img/l8.b67eaacd.jpg";